import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import * as CommonActions from './common.actions';
import { UserModel } from './common.models';
import { JwtUtils } from '@dcs-workspace/shared';
import { of } from 'rxjs';

@Injectable()
export class CommonEffects {
  constructor(
    private actions$: Actions,
    private configurationService: ConfigService
  ) {}

  setConfiguration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonActions.loadConfiguration),
      switchMap(() =>
        this.configurationService.loadConfig().pipe(
          map((configurationModel) =>
            CommonActions.loadConfigurationSuccess({
              config: configurationModel,
            })
          ),
          catchError((error) =>
            of(CommonActions.loadConfigurationError({ error }))
          )
        )
      )
    )
  );
  setUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonActions.loadUser),
      switchMap((action) => {
        const parsedUser = JwtUtils.parseJwt(action.token);
        const user = {
          unique_name: parsedUser.unique_name,
          personId: parsedUser.personId,
        } as UserModel;
        return of(CommonActions.loadUserSuccess({ user }));
      })
    )
  );


}
